import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en';
import ja from './ja';
import ko from './ko';

const resources = {
    ko,
    ja,
    en,
};

i18n.use(initReactI18next)
    .init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
